export default "__VITE_ASSET__423574d9__"